(() => {
  /**
   * Ссылки из настроек секций и из richtext хранятся без префикса локали
   * ("/pages/..."), поэтому на не-основном языке клик уводил на основной.
   * После загрузки дописываем внутренним витринным ссылкам префикс текущей
   * локали, уже локализованные не трогаем.
   */
  const LOCALIZABLE_PATH_RE = /^\/(pages|products|collections|blogs|search|cart|policies)([/?#]|$)/;

  const rootUrl = (window.routes && window.routes.root_url) || '/';
  if (rootUrl === '/') return;
  const prefix = rootUrl.replace(/\/$/, '');

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('a[href^="/"]:not([hreflang])').forEach((anchor) => {
      const href = anchor.getAttribute('href');
      if (!LOCALIZABLE_PATH_RE.test(href)) return;
      if (href.startsWith(`${prefix}/`)) return;
      anchor.setAttribute('href', prefix + href);
    });
  });
})();
